import {createSlice, PayloadAction} from '@reduxjs/toolkit';


export interface InitialStateType {
    birthDate: string | null;
    dateWith: string;
    dateWithNew: string;
    dateTo: string;
    dateToNew: string;
}

const initialState: InitialStateType = {
    birthDate: null,
    dateWith: "",
    dateWithNew:'',
    dateTo: "",
    dateToNew: "",
}

const slice = createSlice({
    name: 'date',
    initialState,
    reducers: {
        setBirthDate(state, action: PayloadAction<string>) {
            state.birthDate = action.payload;
        },
        setWithDate(state, action: PayloadAction<string>) {
            state.dateWith = action.payload;
        },
        setWithDateNew(state, action: PayloadAction<string>) {
            state.dateWithNew = action.payload;
        },
        setToDate(state, action: PayloadAction<string>) {
            state.dateTo = action.payload;
        },
        setToDateNew(state, action: PayloadAction<string>) {
            state.dateToNew = action.payload;
        },
    }
})

export const dateReducer = slice.reducer
export const {setWithDate, setToDate,setToDateNew, setBirthDate,setWithDateNew} = slice.actions
